import { render } from "./TheCellSettings.vue?vue&type=template&id=061ca598&ts=true"
import script from "./TheCellSettings.vue?vue&type=script&lang=ts"
export * from "./TheCellSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__